import CONFIG from 'config';

const env = CONFIG.env;
export const CH_HELP_CENTER_CONTACT = 'help@confidanthealth.com';
// The fee billing charges for a no-show or a cancellation inside 24 hours (ICH-5592). Every
// consent, booking and FAQ text reads it from here so members never see a stale amount.
export const NO_SHOW_FEE_LABEL = '$75.00';
export const S3_BUCKET_URL =
  env === 'prod' || env === 'production'
    ? 'https://confidant-health-prod.s3.amazonaws.com/'
    : 'https://confidant-health.s3.amazonaws.com/';
export const CHATBOT_DEFAULT_AVATAR_URL = 'https://i.imgur.com/Tgbdv8K.png';
export const DEFAULT_IMAGE = 'profileImages/testUser_defaultAvatar.png';
export const DEFAULT_GROUP_IMAGE = 'profileImages/testUser_defaultGroupAvatar.png';

export enum LoginType {
  ADMIN = 'ADMIN',
  PROVIDER = 'PRACTITIONER',
  ADMIN_LABEL = 'Admin',
  PROVIDER_LABEL = 'Provider',
}

export const navItems = [
  {
    title: 'Overview',
    icon: 'fa-regular fa-objects-column',
    link: '/overview',
  },
  {
    title: 'Appointments',
    icon: 'fa-regular fa-calendar-range',
    link: '/appointments',
  },
  {
    title: 'Chatbots',
    icon: 'fa-regular fa-message-bot',
    link: '/chatbots',
  },
  {
    title: 'Chats',
    icon: 'fa-regular fa-messages',
    link: '/chats',
  },
  {
    title: 'Invoices',
    icon: 'fa-regular fa-receipt',
    link: '/invoices',
  },
];

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Intersex', value: 'Intersex' },
];

export const PAYMENT_METHODS = [
  { label: 'Cash', value: 'CASH' },
  { label: 'Insurance', value: 'INSURANCE' },
];
